(function () {
  "use strict";

  const MODAL_ID = "lens-configurator-v2-modal";

  const icons = {
    frame: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M3.5 12.5c1.5-2 3.6-3 6.3-3 1.4 0 2.5.4 3.2 1.1.7-.7 1.8-1.1 3.2-1.1 2.7 0 4.8 1 6.3 3"/><path d="M2.8 13.5c.4 3 2.1 4.7 5 4.7 2.7 0 4.3-1.5 4.7-4.6.1-.7.1-1.2.5-1.2s.4.5.5 1.2c.4 3.1 2 4.6 4.7 4.6 2.9 0 4.6-1.7 5-4.7"/><path d="M12.5 12.9h-1"/></svg>',
    plano: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 3.5c4 0 7.2 3.8 7.2 8.5S16 20.5 12 20.5 4.8 16.7 4.8 12 8 3.5 12 3.5Z"/><path d="M8.6 8.5c1.1-.9 2.2-1.3 3.4-1.3"/></svg>',
    single: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 3.5c4 0 7.2 3.8 7.2 8.5S16 20.5 12 20.5 4.8 16.7 4.8 12 8 3.5 12 3.5Z"/><path d="M12 8v8"/><path d="M8 12h8"/></svg>',
    progressive: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 3.5c4 0 7.2 3.8 7.2 8.5S16 20.5 12 20.5 4.8 16.7 4.8 12 8 3.5 12 3.5Z"/><path d="M8.2 8.5h7.6"/><path d="M9.1 12h5.8"/><path d="M10.3 15.5h3.4"/></svg>',
    readers: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 5.5h6.3c1.2 0 2.2 1 2.2 2.2v10.8c0-1.4-1.1-2.5-2.5-2.5H4V5.5Z"/><path d="M20 5.5h-6.3c-1.2 0-2.2 1-2.2 2.2v10.8c0-1.4 1.1-2.5 2.5-2.5h6V5.5Z"/></svg>',
    clear: '<svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="12" cy="12" r="7.5"/><path d="M8.5 8.5c1-.8 2.1-1.2 3.4-1.2"/></svg>',
    blue: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 3.5 19 6v5.2c0 4.4-2.7 7.7-7 9.3-4.3-1.6-7-4.9-7-9.3V6l7-2.5Z"/><path d="M9 12h6"/><path d="M12 9v6"/></svg>',
    photo: '<svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="8" cy="8" r="3"/><path d="M8 2.7v1.5M8 11.8v1.5M2.7 8h1.5M11.8 8h1.5M4.2 4.2l1 1M10.8 10.8l1 1M11.8 4.2l-1 1M5.2 10.8l-1 1"/><path d="M17.5 8.5a5.8 5.8 0 1 0 0 11.5 6 6 0 0 0 3.8-1.4 5.9 5.9 0 0 1-4.8-5.8c0-1.8.8-3.4 2-4.5-.3.1-.7.2-1 .2Z"/></svg>',
    sun: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M3.5 11.5c1.5-1.4 3.3-2.1 5.4-2.1 1.4 0 2.5.4 3.1 1 .6-.6 1.7-1 3.1-1 2.1 0 3.9.7 5.4 2.1"/><path d="M4.2 12.3c.2 3 1.8 4.7 4.6 4.7 2.5 0 3.8-1.4 4.1-4.3.1-.6.1-.9.1-.9s0 .3.1.9c.3 2.9 1.6 4.3 4.1 4.3 2.8 0 4.4-1.7 4.6-4.7"/><path d="M12 12h0"/></svg>',
    tinted: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 3.5c4 0 7.2 3.8 7.2 8.5S16 20.5 12 20.5 4.8 16.7 4.8 12 8 3.5 12 3.5Z"/><path d="M4.9 12h14.2"/><path d="M6.3 14.8c1.2 3.4 3.2 5.1 5.7 5.1s4.5-1.7 5.7-5.1"/></svg>',
    mirror: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 3.5 20.5 12 12 20.5 3.5 12 12 3.5Z"/><path d="M8 12h8"/><path d="M12 8v8"/></svg>',
    mercury: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 3.5 14.2 9l5.8 1.1-4.4 3.8.8 5.9L12 16.8l-4.4 3 .8-5.9L4 10.1 9.8 9 12 3.5Z"/><path d="M19.5 3.8v3"/><path d="M18 5.3h3"/></svg>',
    oleophobic: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5.2 13.1c2.2-2.8 4.6-4.2 7.1-4.2s4.9 1.4 7.1 4.2"/><path d="M4.6 13.8c.5 3 2.2 4.6 5.1 4.6 2.5 0 4-1.3 4.5-4 .2-.8.2-1.4.6-1.4s.4.6.6 1.4c.5 2.7 2 4 4.5 4 2.9 0 4.6-1.6 5.1-4.6"/><path d="M8 6.5c.7-1.1 1.4-1.8 2.2-2.4.8.6 1.5 1.3 2.2 2.4"/><path d="M10.2 4.1v4.1"/><path d="M15.8 5.2c.7.7 1.3 1.5 1.7 2.4"/></svg>',
    blue_filter: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5 12.6c2-2.4 4.3-3.6 7-3.6s5 1.2 7 3.6"/><path d="M4.3 13.4c.4 2.8 2 4.4 4.8 4.4 2.4 0 3.8-1.3 4.2-3.9.1-.7.2-1.2.7-1.2s.6.5.7 1.2c.4 2.6 1.8 3.9 4.2 3.9 2.8 0 4.4-1.6 4.8-4.4"/><path d="M8 6.2h8"/><path d="M9.4 3.8h5.2"/><path d="M10.8 6.2 9.6 9"/><path d="M13.2 6.2 14.4 9"/></svg>',
    index: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5 8.5 12 4l7 4.5-7 4.5L5 8.5Z"/><path d="M5 12l7 4.5L19 12"/><path d="M5 15.5 12 20l7-4.5"/></svg>',
    addon: '<svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="12" cy="12" r="8"/><path d="M12 8v8"/><path d="M8 12h8"/></svg>'
  };

  const config = {
    currency: "$",
    rxTypes: [
      { id: "frame_only", name: "Frame Only", icon: "frame", desc: "No lenses included. The frame will be shipped without prescription or plano lenses.", price: 0, requiresRx: false, frameOnly: true },
      { id: "non_rx", name: "Non-prescription", icon: "plano", desc: "Plano lenses for fashion or sunwear.", price: 0, requiresRx: false },
      { id: "single", name: "Single vision", icon: "single", desc: "For distance, reading, nearsightedness, farsightedness, or astigmatism.", price: 0, requiresRx: true },
      { id: "progressive", name: "Progressive", icon: "progressive", desc: "Distance, intermediate, and near vision in one pair.", price: 60, requiresRx: true, requiresAdd: true },
      { id: "readers", name: "Readers", icon: "readers", desc: "Reading lenses with near-vision support.", price: 12, requiresRx: true }
    ],
    inputMethods: [
      { id: "manual", name: "Enter prescription", desc: "Fill in OD, OS, PD, and ADD if needed.", price: 0 }
    ],
    lensPackages: [
      { id: "clear", name: "Clear lenses", icon: "clear", desc: "Clear lenses for your selected prescription type.", price: 0, color: false },
      { id: "blue", name: "Blue light lenses", icon: "blue", desc: "For screens and daily digital use.", price: 15, color: false },
      { id: "photo", name: "Photochromic lenses", icon: "photo", desc: "Clear indoors, darker outdoors.", price: 35, color: true, colorSet: "photo" },
      { id: "polarized", name: "Polarized sunglasses", icon: "sun", desc: "Reduce glare for driving and outdoor use.", price: 40, color: true, colorSet: "polarized" },
      { id: "tinted", name: "Tinted sunglasses", icon: "tinted", desc: "Fixed tint colors with daily-wear densities.", price: 18, color: true, colorSet: "tinted" }
    ],
    indexes: [
      { id: "1.56", name: "1.56 Standard", icon: "index", desc: "Basic lens index.", price: 0 },
      { id: "1.60", name: "1.60 Thin", icon: "index", desc: "Thinner and lighter for medium prescriptions.", price: 20 },
      { id: "1.67", name: "1.67 Ultra thin", icon: "index", desc: "A better look for stronger prescriptions.", price: 45 },
      { id: "1.74", name: "1.74 Premium thin", icon: "index", desc: "Thinnest option for high prescriptions.", price: 80 },
      { id: "1.56_bluelight", name: "1.56 Standard Blue Light", icon: "blue", desc: "Standard index with blue light filtering.", price: 10 },
      { id: "1.60_bluelight", name: "1.60 Thin Blue Light", icon: "blue", desc: "Thin index with blue light filtering.", price: 30 },
      { id: "1.67_bluelight", name: "1.67 Ultra Thin Blue Light", icon: "blue", desc: "Ultra thin index with blue light filtering.", price: 55 }
    ],
    addons: [
      { id: "ar", name: "Anti-reflective coating", icon: "addon", desc: "Reduce reflections and improve clarity.", price: 12 },
      { id: "oleophobic", name: "Super Hydrophobic Coating", icon: "oleophobic", desc: "Helps repel water, oil, and fingerprints for easier cleaning.", price: 10 },
      { id: "blue_light_filtering", name: "Blue Light Filtering", icon: "blue_filter", desc: "Adds blue light filtering for extra screen comfort.", price: 10 },
      { id: "hard", name: "Scratch-resistant coating", icon: "addon", desc: "Improved daily durability.", price: 8 },
      { id: "rush", name: "Rush processing", icon: "addon", desc: "Priority handling for this order.", price: 15 },
      { id: "custom_color", name: "Custom color", icon: "addon", desc: "Special tint or coating request.", price: 20 },
      { id: "prism", name: "Prism prescription", icon: "addon", desc: "Prism details included in order notes.", price: 25 }
    ],
    colors: [
      { id: "Gray", name: "Gray", css: "linear-gradient(135deg, #e5e7eb 0%, #9ca3af 52%, #4b5563 100%)", fallback: "#9ca3af" },
      { id: "Brown", name: "Brown", css: "linear-gradient(135deg, #f0d0a3 0%, #a16207 54%, #57351d 100%)", fallback: "#a16207" },
      { id: "Green", name: "Green", css: "linear-gradient(135deg, #bbf7d0 0%, #15803d 56%, #14532d 100%)", fallback: "#15803d" },
      { id: "Blue", name: "Blue", css: "linear-gradient(135deg, #bae6fd 0%, #2563eb 56%, #1e3a8a 100%)", fallback: "#2563eb" },
      { id: "Pink", name: "Pink", css: "linear-gradient(135deg, #fbcfe8 0%, #db2777 56%, #831843 100%)", fallback: "#db2777" },
      { id: "Purple", name: "Purple", css: "linear-gradient(135deg, #ddd6fe 0%, #7c3aed 56%, #4c1d95 100%)", fallback: "#7c3aed" },
      { id: "Yellow", name: "Yellow", css: "linear-gradient(135deg, #fef3c7 0%, #facc15 50%, #b45309 100%)", fallback: "#facc15" },
      { id: "Gradient Gray", name: "Gradient Gray", css: "linear-gradient(135deg, rgba(248,250,252,0.96) 0%, rgba(156,163,175,0.78) 48%, rgba(31,41,55,0.92) 100%)", fallback: "#cbd5e1" },
      { id: "Gradient Brown", name: "Gradient Brown", css: "linear-gradient(135deg, rgba(254,243,199,0.96) 0%, rgba(180,83,9,0.76) 50%, rgba(68,35,18,0.92) 100%)", fallback: "#d97706" },
      { id: "Photochromic Gray", name: "Photochromic Gray", css: "linear-gradient(135deg, rgba(248,250,252,0.92) 0%, rgba(203,213,225,0.72) 42%, rgba(75,85,99,0.88) 100%)", fallback: "#cbd5e1" },
      { id: "Photochromic Brown", name: "Photochromic Brown", css: "linear-gradient(135deg, rgba(255,247,237,0.92) 0%, rgba(217,119,6,0.68) 48%, rgba(92,51,23,0.88) 100%)", fallback: "#f3c178" }
    ],
    colorSets: {
      photo: [
        { id: "Photochromic Gray", name: "Photochromic Gray", css: "linear-gradient(135deg, rgba(248,250,252,0.92) 0%, rgba(203,213,225,0.72) 42%, rgba(75,85,99,0.88) 100%)", fallback: "#cbd5e1" },
        { id: "Photochromic Brown", name: "Photochromic Brown", css: "linear-gradient(135deg, rgba(255,247,237,0.92) 0%, rgba(217,119,6,0.68) 48%, rgba(92,51,23,0.88) 100%)", fallback: "#f3c178" },
        { id: "Photochromic Pink", name: "Photochromic Pink", css: "linear-gradient(135deg, rgba(253,242,248,0.94) 0%, rgba(244,114,182,0.64) 48%, rgba(157,23,77,0.82) 100%)", fallback: "#f9a8d4" },
        { id: "Photochromic Purple", name: "Photochromic Purple", css: "linear-gradient(135deg, rgba(245,243,255,0.94) 0%, rgba(167,139,250,0.64) 48%, rgba(91,33,182,0.84) 100%)", fallback: "#a78bfa" },
        { id: "Photochromic Blue", name: "Photochromic Blue", css: "linear-gradient(135deg, rgba(239,246,255,0.94) 0%, rgba(96,165,250,0.64) 48%, rgba(30,64,175,0.84) 100%)", fallback: "#93c5fd" },
        { id: "Photochromic Green", name: "Photochromic Green", css: "linear-gradient(135deg, rgba(240,253,244,0.94) 0%, rgba(74,222,128,0.62) 48%, rgba(22,101,52,0.84) 100%)", fallback: "#86efac" }
      ],
      polarized: [
        { id: "Polarized Gray", name: "Polarized Gray", css: "linear-gradient(135deg, #f8fafc 0%, #9ca3af 46%, #374151 100%)", fallback: "#9ca3af" },
        { id: "Polarized Brown", name: "Polarized Brown", css: "linear-gradient(135deg, #fef3c7 0%, #b45309 48%, #451a03 100%)", fallback: "#b45309" },
        { id: "Polarized Green", name: "Polarized Green", css: "linear-gradient(135deg, #dcfce7 0%, #16a34a 48%, #14532d 100%)", fallback: "#16a34a" }
      ],
      tinted: [
        { id: "Tinted Gray 85%", name: "Tinted Gray 85%", css: "linear-gradient(135deg, #e5e7eb 0%, #6b7280 48%, #111827 100%)", fallback: "#6b7280" },
        { id: "Tinted Brown 85%", name: "Tinted Brown 85%", css: "linear-gradient(135deg, #fde68a 0%, #92400e 48%, #3f1d0b 100%)", fallback: "#92400e" },
        { id: "Tinted Pink 30%", name: "Tinted Pink 30%", css: "linear-gradient(135deg, rgba(253,242,248,0.96) 0%, rgba(244,114,182,0.52) 58%, rgba(190,24,93,0.66) 100%)", fallback: "#f9a8d4" },
        { id: "Tinted Purple 30%", name: "Tinted Purple 30%", css: "linear-gradient(135deg, rgba(245,243,255,0.96) 0%, rgba(167,139,250,0.52) 58%, rgba(109,40,217,0.66) 100%)", fallback: "#c4b5fd" },
        { id: "Tinted Blue 30%", name: "Tinted Blue 30%", css: "linear-gradient(135deg, rgba(239,246,255,0.96) 0%, rgba(96,165,250,0.52) 58%, rgba(37,99,235,0.66) 100%)", fallback: "#93c5fd" },
        { id: "Tinted Green 30%", name: "Tinted Green 30%", css: "linear-gradient(135deg, rgba(240,253,244,0.96) 0%, rgba(74,222,128,0.52) 58%, rgba(22,163,74,0.66) 100%)", fallback: "#86efac" }
      ]
    },
    mirrors: [
      { id: "Silver", name: "Mirror Silver", css: "linear-gradient(135deg, #ffffff 0%, #cbd5e1 32%, #64748b 52%, #f8fafc 78%, #94a3b8 100%)", fallback: "#cbd5e1" },
      { id: "Gold", name: "Mirror Gold", css: "linear-gradient(135deg, #fff7ad 0%, #f59e0b 48%, #fef3c7 72%, #b45309 100%)", fallback: "#f59e0b" },
      { id: "Blue", name: "Mirror Blue", css: "linear-gradient(135deg, #e0f2fe 0%, #0284c7 46%, #38bdf8 70%, #1e3a8a 100%)", fallback: "#0284c7" },
      { id: "Red", name: "Mirror Red", css: "linear-gradient(135deg, #fee2e2 0%, #dc2626 48%, #fb7185 72%, #7f1d1d 100%)", fallback: "#dc2626" },
      { id: "Green", name: "Mirror Green", css: "linear-gradient(135deg, #dcfce7 0%, #16a34a 48%, #86efac 72%, #14532d 100%)", fallback: "#16a34a" },
      { id: "Purple", name: "Mirror Purple", css: "linear-gradient(135deg, #f3e8ff 0%, #7e22ce 48%, #c084fc 72%, #3b0764 100%)", fallback: "#7e22ce" }
    ],
    mercuryColors: [
      { id: "Rainbow Red", name: "Rainbow Red", css: "linear-gradient(135deg, #ffe34e 0%, #f58a1f 38%, #d42b38 72%, #63202b 100%)", fallback: "#f58a1f" },
      { id: "Rainbow Green", name: "Rainbow Green", css: "linear-gradient(135deg, #1d315d 0%, #007c76 44%, #39c27a 72%, #d6e83e 100%)", fallback: "#007c76" },
      { id: "Rainbow Blue", name: "Rainbow Blue", css: "linear-gradient(135deg, #32156f 0%, #1547d4 42%, #23a9ff 76%, #7de3ff 100%)", fallback: "#1547d4" },
      { id: "Ice Blue", name: "Ice Blue", css: "linear-gradient(135deg, #0a4875 0%, #0c9cc2 48%, #8eefff 100%)", fallback: "#0c9cc2" },
      { id: "Rainbow Purple", name: "Rainbow Purple", css: "linear-gradient(135deg, #32202d 0%, #6e264f 36%, #d159a8 68%, #f2b36c 100%)", fallback: "#6e264f" },
      { id: "Rainbow Yellow", name: "Rainbow Yellow", css: "linear-gradient(135deg, #0f5f5e 0%, #5bbb64 36%, #e6ee3f 68%, #fff16a 100%)", fallback: "#e6ee3f" },
      { id: "Purple Red", name: "Purple Red", css: "linear-gradient(135deg, #fb8a25 0%, #d63f3f 38%, #a72a68 72%, #512344 100%)", fallback: "#d63f3f" },
      { id: "White Silver", name: "White Silver", css: "linear-gradient(135deg, #ffffff 0%, #d9e1e4 35%, #7f8d92 70%, #f9fbfb 100%)", fallback: "#d9e1e4" },
      { id: "Rainbow Gold", name: "Rainbow Gold", css: "linear-gradient(135deg, #fff06a 0%, #e3c42e 45%, #9d7821 78%, #f7e37b 100%)", fallback: "#e3c42e" }
    ],
    depths: ["10%", "30%", "50%", "70%", "85%"]
  };

  const stateByRoot = new WeakMap();
  const boundForms = new WeakSet();
  let activeRoot = null;

  const steps = [
    { id: "rx_type", title: "Choose prescription type", help: "Choose how you will use your glasses.", render: renderRxType },
    { id: "prescription", title: "Enter prescription", help: "Enter the values from your prescription. Check OD, OS and PD before continuing.", render: renderPrescription },
    { id: "lens_package", title: "Choose lens package", help: "Clear, blue light, photochromic, polarized, or tinted.", render: renderLensPackage },
    { id: "lens_color", title: "Choose lens color", help: "Select the available color for this lens package.", render: renderColor },
    { id: "index_addons", title: "Choose index and add-ons", help: "Choose one lens index, then review the available optional add-ons.", render: renderIndexAddons },
    { id: "review", title: "Review configuration", help: "Confirm the configuration before adding to cart.", render: renderReview }
  ];

  function activeSteps(state) {
    normalizeState(state);
    const rx = byId(config.rxTypes, state.rxType);
    const pkg = selectedPackage(state);
    return steps.filter((step) => {
      if (step.id === "prescription") return rx.requiresRx && state.inputMethod === "manual";
      if (step.id === "lens_package") return !rx.frameOnly;
      if (step.id === "lens_color") return !rx.frameOnly && pkg.color;
      if (step.id === "index_addons") return !rx.frameOnly;
      return true;
    });
  }

  function currentStepIndex(state, active) {
    return Math.min(state.step, active.length - 1);
  }

  function setStepById(state, stepId) {
    const active = activeSteps(state);
    const index = active.findIndex((step) => step.id === stepId);
    state.step = index >= 0 ? index : active.length - 1;
  }

  function isPrescriptionStep(state) {
    const active = activeSteps(state);
    const index = currentStepIndex(state, active);
    return active[index] && active[index].id === "prescription";
  }

  function isReviewStep(state) {
    const active = activeSteps(state);
    const index = currentStepIndex(state, active);
    return index === active.length - 1;
  }

  function createState(root) {
    const framePrice = Number.parseFloat(root.dataset.lcFramePrice || "0") || 0;
    const state = {
      step: 0,
      framePrice,
      rxType: "frame_only",
      inputMethod: "manual",
      lensPackage: "clear",
      index: "1.56",
      pdMode: "single",
      color: "Gray",
      depth: "50%",
      mirror: "Silver",
      mercury: "Rainbow Red",
      addons: new Set(),
      note: "",
      confirmed: false,
      rx: {
        odSph: "",
        odCyl: "",
        odAxis: "",
        osSph: "",
        osCyl: "",
        osAxis: "",
        pd: "",
        rpd: "",
        lpd: "",
        add: ""
      }
    };
    stateByRoot.set(root, state);
    return state;
  }

  function getState(root) {
    return stateByRoot.get(root) || createState(root);
  }

  function byId(list, id) {
    return list.find((item) => item.id === id);
  }

  function money(value) {
    return `${config.currency}${Number(value).toFixed(2).replace(".00", "")}`;
  }

  
  function rxNumber(value) {
    const parsed = Number.parseFloat(String(value || "").trim());
    return Number.isFinite(parsed) ? parsed : null;
  }

  function hasHighMyopiaRx(state) {
    const odSph = rxNumber(state.rx && state.rx.odSph);
    const osSph = rxNumber(state.rx && state.rx.osSph);
    return odSph !== null && odSph <= -8 || osSph !== null && osSph <= -8;
  }

  function allowedLensPackages(state) {
    const allowedByRxType = {
      frame_only: ["clear"],
      non_rx: ["clear", "blue", "tinted", "photo", "polarized"],
      single: ["clear", "blue", "tinted", "photo", "polarized"],
      readers: ["clear", "blue"],
      progressive: ["clear", "blue", "photo"]
    };
    const allowedIds = allowedByRxType[state.rxType] || allowedByRxType.frame_only;
    return config.lensPackages.filter((item) => allowedIds.includes(item.id));
  }

  function allowedIndexes(state) {
    const baseIndexes = ["1.56", "1.60", "1.67", "1.74"];
    let allowedIds = baseIndexes;

    if (state.rxType === "frame_only" || state.rxType === "non_rx") {
      allowedIds = ["1.56"];
    } else if (state.rxType === "readers") {
      allowedIds = ["1.56", "1.60", "1.67"];
    } else if (state.lensPackage === "clear") {
      allowedIds = ["1.56", "1.60", "1.67", "1.74", "1.56_bluelight", "1.60_bluelight", "1.67_bluelight"];
    } else if (state.lensPackage === "polarized") {
      allowedIds = ["1.56", "1.60", "1.67"];
    }

    if (!["frame_only", "non_rx"].includes(state.rxType) && hasHighMyopiaRx(state)) {
      allowedIds = allowedIds.filter((id) => id !== "1.56" && id !== "1.56_bluelight");
    }

    return config.indexes.filter((item) => allowedIds.includes(item.id));
  }

  function allowedAddons(state) {
    if (["single", "progressive", "readers"].includes(state.rxType)) {
      const allowedIds = ["oleophobic"];
      if (["photo", "tinted"].includes(state.lensPackage)) {
        allowedIds.push("blue_light_filtering");
      }
      return config.addons.filter((addon) => allowedIds.includes(addon.id));
    }
    return [];
  }

  function normalizeState(state) {
    const packages = allowedLensPackages(state);
    if (!packages.some((item) => item.id === state.lensPackage)) {
      state.lensPackage = packages[0] ? packages[0].id : "clear";
    }

    const colors = colorOptions(state);
    if (colors.length && !colors.some((item) => item.id === state.color)) {
      state.color = colors[0].id;
    }

    const indexes = allowedIndexes(state);
    if (!indexes.some((item) => item.id === state.index)) {
      state.index = indexes[0] ? indexes[0].id : "1.56";
    }

    if (["frame_only", "non_rx"].includes(state.rxType)) {
      state.index = "1.56";
      state.addons.clear();
    } else {
      const allowedAddonIds = allowedAddons(state).map((addon) => addon.id);
      Array.from(state.addons).forEach((addonId) => {
        if (!allowedAddonIds.includes(addonId)) state.addons.delete(addonId);
      });
    }

    if (state.rxType === "frame_only") {
      state.lensPackage = "clear";
    }

    return state;
  }

  function selectedPackage(state) {
    if (state.rxType === "frame_only") return { id: "frame_only", name: "Frame Only", price: 0, color: false };
    return byId(config.lensPackages, state.lensPackage);
  }

  function selectedIndex(state) {
    if (state.rxType === "frame_only") return { id: "none", name: "None", price: 0 };
    return byId(config.indexes, state.index);
  }

  function colorOptions(state) {
    const pkg = selectedPackage(state);
    if (!pkg.color) return [];
    return config.colorSets[pkg.colorSet] || config.colors;
  }

  function colorText(state) {
    const pkg = selectedPackage(state);
    if (state.rxType === "frame_only") return "None";
    if (!pkg.color) return "None";
    if (pkg.mercury) return byId(config.mercuryColors, state.mercury).name;
    const color = byId(colorOptions(state), state.color);
    const parts = [color ? color.name : state.color];
    if (pkg.mirror) parts.push(byId(config.mirrors, state.mirror).name);
    return parts.join(" / ");
  }

  function selectedAddons(state) {
    if (state.rxType === "frame_only") return [];
    return allowedAddons(state).filter((addon) => state.addons.has(addon.id));
  }

  function priceRows(state) {
    normalizeState(state);
    const rx = byId(config.rxTypes, state.rxType);
    if (rx.frameOnly) {
      return [
        { label: "Selection", value: "Frame Only", price: 0 },
        { label: "Lens package", value: "Frame Only", price: 0 },
        { label: "Lens index", value: "None", price: 0 }
      ];
    }
    const method = byId(config.inputMethods, state.inputMethod);
    const pkg = selectedPackage(state);
    const index = selectedIndex(state);
    return [
      { label: "Prescription type", value: rx.name, price: rx.price },
      { label: "Prescription method", value: method.name, price: method.price },
      { label: "Lens package", value: pkg.name, price: pkg.price },
      ...(pkg.color ? [{ label: "Lens color", value: colorText(state), price: 0 }] : []),
      { label: "Lens index", value: index.name, price: index.price },
      ...selectedAddons(state).map((addon) => ({ label: "Add-on", value: addon.name, price: addon.price }))
    ];
  }

  function lensPrice(state) {
    return priceRows(state).reduce((sum, row) => sum + row.price, 0);
  }

  function totalPrice(state) {
    return state.framePrice + lensPrice(state);
  }

  function rxText(state) {
    const rxType = byId(config.rxTypes, state.rxType);
    if (rxType.frameOnly) return "Not required";
    const method = byId(config.inputMethods, state.inputMethod);
    if (!rxType.requiresRx) return "Non-prescription / Plano";
    if (state.inputMethod !== "manual") return method.name;
    const cleanValue = (value) => String(value || "").trim();
    const eyeText = (label, sph, cyl, axis) => {
      const cleanSph = cleanValue(sph);
      const cleanCyl = cleanValue(cyl);
      const cleanAxis = cleanValue(axis);
      const hasCylinder = cleanCyl !== "" && Number(cleanCyl) !== 0;
      if (hasCylinder || cleanAxis) {
        return `${label}: SPH ${cleanSph}, CYL ${cleanCyl || "0.00"}, AXIS ${cleanAxis}`;
      }
      return `${label}: SPH ${cleanSph}`;
    };
    const pd = state.pdMode === "single" ? `PD ${state.rx.pd}mm` : `RPD ${state.rx.rpd}mm / LPD ${state.rx.lpd}mm`;
    const add = rxType.requiresAdd ? ` / ADD ${state.rx.add ? `+${Number(state.rx.add).toFixed(2)}` : ""}` : "";
    return [
      eyeText("OD", state.rx.odSph, state.rx.odCyl, state.rx.odAxis),
      eyeText("OS", state.rx.osSph, state.rx.osCyl, state.rx.osAxis),
      `${pd}${add}`
    ].join("\n");
  }

  function orderNote(root, state) {
    const rx = byId(config.rxTypes, state.rxType);
    if (rx.frameOnly) {
      return [
        `Product: ${root.dataset.lcProductTitle || ""}`,
        "Lens Configuration: Frame Only",
        "Prescription: Not required",
        "Lens Package: Frame Only",
        "Lens Color: None",
        "Lens Index: None",
        "Add-ons: None",
        "Lens Upgrade Price: $0",
        "Pricing Note: Lens upgrade will be added to the cart as a separate upgrade item."
      ].join("\n");
    }
    const method = byId(config.inputMethods, state.inputMethod);
    const pkg = selectedPackage(state);
    const index = selectedIndex(state);
    const addons = selectedAddons(state).map((addon) => addon.name).join(", ") || "None";
    return [
      `Product: ${root.dataset.lcProductTitle || ""}`,
      `Rx Type: ${rx.name}`,
      `Prescription Method: ${method.name}`,
      rxText(state),
      `Lens Package: ${pkg.name}`,
      `Lens Color: ${colorText(state)}`,
      `Lens Index: ${index.name}`,
      `Add-ons: ${addons}`,
      `Lens Upgrade Price: ${money(lensPrice(state))}`,
      "Pricing Note: Lens upgrade will be added to the cart as a separate upgrade item.",
      `Estimated Total: ${money(totalPrice(state))}`,
      `Customer Note: ${state.note || "None"}`
    ].join("\n");
  }

  function lensConfigurationText(state) {
    const rx = byId(config.rxTypes, state.rxType);
    if (rx.frameOnly) return "Frame Only";
    return [
      rx.name,
      selectedPackage(state).name,
      selectedIndex(state).name,
      colorText(state) !== "None" ? colorText(state) : ""
    ].filter(Boolean).join(" / ");
  }

  function buildLensProperties(root, state) {
    const pkg = selectedPackage(state);
    const index = selectedIndex(state);
    const addons = selectedAddons(state).map((addon) => addon.name).join(", ") || "None";
    const isFrameOnly = byId(config.rxTypes, state.rxType).frameOnly;

    if (isFrameOnly) {
      return {
        "Lens Configuration": "Frame Only",
        "Prescription": "Not required",
        "Lens Package": "Frame Only",
        "Lens Color": "None",
        "Lens Index": "None",
        "Lens Add-ons": "None",
        "Lens Upgrade Price": "$0"
      };
    }

    return {
      "Lens Configuration": lensConfigurationText(state),
      "Prescription": rxText(state),
      "Lens Package": pkg.name,
      "Lens Color": colorText(state),
      "Lens Index": index.name,
      "Lens Add-ons": addons,
      "Lens Upgrade Price": money(lensPrice(state))
    };
  }

  function upgradeVariantIdForPrice(price) {
    if (typeof window.__joyeLensUpgradeVariantIdForPrice !== "function") return null;
    return window.__joyeLensUpgradeVariantIdForPrice(price);
  }

  function ensureModal() {
    let modal = document.getElementById(MODAL_ID);
    if (modal) return modal;

    modal = document.createElement("div");
    modal.id = MODAL_ID;
    modal.className = "lc-v2-modal";
    modal.setAttribute("aria-hidden", "true");
    modal.innerHTML = `
      <div class="lc-v2-modal__shade" data-lc-close></div>
      <div class="lc-v2-dialog" role="dialog" aria-modal="true" aria-label="Lens configurator">
        <div class="lc-v2-dialog__head">
          <div>
            <p class="lc-v2-step-label" data-lc-step-label>Step 1 of 7</p>
            <h3 data-lc-step-title>Choose prescription type</h3>
            <p class="lc-v2-step-help" data-lc-step-help>Select how you want to use these lenses.</p>
          </div>
          <button class="lc-v2-close" type="button" data-lc-close aria-label="Close">&times;</button>
        </div>
        <div class="lc-v2-progress" data-lc-progress></div>
        <div class="lc-v2-body" data-lc-body></div>
        <div class="lc-v2-foot">
          <div class="lc-v2-foot__back">
            <button class="lc-v2-button" type="button" data-lc-back>Back</button>
          </div>
          <div class="lc-v2-total">
            <span>Lens upgrade</span>
            <strong data-lc-lens-price>$0</strong>
          </div>
          <p class="lc-v2-warning" data-lc-warning></p>
          <div class="lc-v2-foot__next">
            <button class="lc-v2-button lc-v2-button--primary" type="button" data-lc-next>Next</button>
          </div>
        </div>
      </div>
    `;
    document.body.appendChild(modal);
    bindModal(modal);
    return modal;
  }

  function openModal(root) {
    activeRoot = root;
    const state = getState(root);
    normalizeState(state);
    state.step = currentStepIndex(state, activeSteps(state));
    const modal = ensureModal();
    modal.classList.add("is-open");
    modal.setAttribute("aria-hidden", "false");
    document.documentElement.style.overflow = "hidden";
    renderModal();
  }

  function closeModal() {
    const modal = document.getElementById(MODAL_ID);
    if (!modal) return;
    modal.classList.remove("is-open");
    modal.setAttribute("aria-hidden", "true");
    document.documentElement.style.overflow = "";
  }

  function renderModal() {
    if (!activeRoot) return;
    const modal = ensureModal();
    const state = getState(activeRoot);
    normalizeState(state);
    const active = activeSteps(state);
    state.step = currentStepIndex(state, active);
    const step = active[state.step];
    modal.querySelector("[data-lc-step-label]").textContent = `Step ${state.step + 1} of ${active.length}`;
    modal.querySelector("[data-lc-step-title]").textContent = step.title;
    modal.querySelector("[data-lc-step-help]").textContent = step.help;
    modal.querySelector("[data-lc-progress]").innerHTML = active.map((_, index) => `<span class="${index <= state.step ? "is-active" : ""}"></span>`).join("");
    modal.querySelector("[data-lc-body]").innerHTML = `<div class="lc-v2-step-panel">${step.render(activeRoot, state)}</div>`;
    modal.querySelector("[data-lc-back]").disabled = state.step === 0;
    const nextButton = modal.querySelector("[data-lc-next]");
    if (state.step === active.length - 1) {
      nextButton.textContent = state.rxType === "frame_only"
        ? "Add frame to cart"
        : "Add frame & lenses to cart";
    } else {
      nextButton.textContent = "Next";
    }
    modal.querySelector("[data-lc-lens-price]").textContent = money(lensPrice(state));
    modal.querySelector("[data-lc-warning]").textContent = visibleValidationMessages(state).join(" ");
  }

  function renderSummary(root) {
    const state = getState(root);
    const summary = root.querySelector("[data-lc-summary]");
    if (!summary) return;
    if (!state.confirmed) {
      summary.textContent = "No lens selected yet.";
      return;
    }
    if (state.rxType === "frame_only") {
      summary.textContent = "Frame Only\nNo lenses included.\nLens upgrade: $0";
      return;
    }
    summary.textContent = [
      `${byId(config.rxTypes, state.rxType).name} / ${selectedPackage(state).name} / ${selectedIndex(state).name}`,
      selectedPackage(state).color ? colorText(state) : "",
      `Lens upgrade: ${money(lensPrice(state))}`,
      "Added as a separate cart item"
    ].filter(Boolean).join("\n");
  }

  function validate(state) {
    const messages = [];
    const rx = byId(config.rxTypes, state.rxType);
    if (!rx.requiresRx || state.inputMethod !== "manual") return messages;

    const isBlank = (value) => String(value || "").trim() === "";
    const isNumberInRange = (value, min, max) => {
      if (isBlank(value)) return false;
      const number = Number(value);
      return Number.isFinite(number) && number >= min && number <= max;
    };
    const requireField = (key, label) => {
      if (isBlank(state.rx[key])) messages.push(`${label} is required.`);
    };
    const requireAxis = (key, label) => {
      if (isBlank(state.rx[key])) {
        messages.push(`${label} is required.`);
        return;
      }
      if (!isNumberInRange(state.rx[key], 0, 180)) messages.push("Axis must be between 0 and 180.");
    };
    const validateAxisIfFilled = (key) => {
      if (!isBlank(state.rx[key]) && !isNumberInRange(state.rx[key], 0, 180)) {
        messages.push("Axis must be between 0 and 180.");
      }
    };
    const validateCylinderAxis = (cylKey, axisKey, axisLabel) => {
      if (!isBlank(state.rx[cylKey]) && Number(state.rx[cylKey]) !== 0) {
        requireAxis(axisKey, axisLabel);
      } else {
        validateAxisIfFilled(axisKey);
      }
    };
    const requirePd = () => {
      if (state.pdMode === "dual") {
        if (!isNumberInRange(state.rx.rpd, 20, 45)) messages.push("RPD must be between 20 and 45.");
        if (!isNumberInRange(state.rx.lpd, 20, 45)) messages.push("LPD must be between 20 and 45.");
      } else if (!isNumberInRange(state.rx.pd, 40, 80)) {
        messages.push("PD must be between 40 and 80.");
      }
    };

    if (state.rxType === "readers") {
      requireField("odSph", "OD SPH");
      requireField("osSph", "OS SPH");
      requirePd();
      validateCylinderAxis("odCyl", "odAxis", "OD AXIS");
      validateCylinderAxis("osCyl", "osAxis", "OS AXIS");
      return messages;
    }

    ["odSph", "osSph"].forEach((key) => {
      const labels = {
        odSph: "OD SPH",
        osSph: "OS SPH"
      };
      requireField(key, labels[key]);
    });
    validateCylinderAxis("odCyl", "odAxis", "OD AXIS");
    validateCylinderAxis("osCyl", "osAxis", "OS AXIS");
    requirePd();

    if (rx.requiresAdd && isBlank(state.rx.add)) {
      messages.push("ADD is required for progressive lenses.");
    }

    return messages;
  }

  function visibleValidationMessages(state) {
    return isPrescriptionStep(state) || isReviewStep(state) ? validate(state) : [];
  }

  function setSnippetProperty(root, name, value) {
    const input = root.querySelector(`[data-lc-property="${name}"]`);
    if (input) input.value = value;
  }

  function findDawnProductForm(root) {
    return root.closest('form[action*="/cart/add"]') ||
      document.querySelector('product-form form[action*="/cart/add"]') ||
      document.querySelector('form[action*="/cart/add"]');
  }

  function syncPropertiesToDawnForm(root) {
    const form = findDawnProductForm(root);
    if (!form) return;
    root.querySelectorAll("[data-lc-property]").forEach((source) => {
      let target = form.querySelector(`input[name="${source.name}"]`);
      if (!target) {
        target = document.createElement("input");
        target.type = "hidden";
        target.name = source.name;
        target.setAttribute("data-lc-generated-property", "true");
        form.appendChild(target);
      }
      target.value = source.value;
    });
  }

  function writeProperties(root) {
    const state = getState(root);
    normalizeState(state);
    const properties = buildLensProperties(root, state);
    Object.keys(properties).forEach((name) => {
      setSnippetProperty(root, name, properties[name]);
    });
    syncPropertiesToDawnForm(root);
  }

  function choiceMarkup(list, selected, group) {
    return `<div class="lc-v2-choice-grid">${list.map((item) => `
      <button class="lc-v2-choice ${item.id === selected ? "is-active" : ""}" type="button" data-lc-group="${group}" data-lc-id="${item.id}">
        <span class="lc-v2-choice__top">
          <span class="lc-v2-choice-icon" aria-hidden="true">${icons[item.icon] || icons.clear}</span>
          <span class="lc-v2-choice__check" aria-hidden="true"></span>
        </span>
        <span class="lc-v2-choice__content">
          <strong>${item.name}</strong>
          <span>${item.desc}</span>
        </span>
        <em class="lc-v2-choice__price lc-v2-price-badge">${item.price ? `+${money(item.price)}` : "Included"}</em>
      </button>
    `).join("")}</div>`;
  }

  function renderRxType(root, state) {
    return choiceMarkup(config.rxTypes, state.rxType, "rxType");
  }

  function renderInputMethod(root, state) {
    if (state.rxType === "frame_only") {
      return `<div class="lc-v2-review-card"><h4>Frame Only</h4><p>No prescription method is needed because no lenses are included.</p></div>`;
    }
    return choiceMarkup(config.inputMethods, state.inputMethod, "inputMethod");
  }

  function powerOptions(min, max, step, selected) {
    const options = [`<option value="" ${selected === "" ? "selected" : ""}>Select</option>`];
    for (let value = min; value <= max + 0.001; value += step) {
      const val = value.toFixed(2);
      const text = Math.abs(value) < 0.001 ? "0.00 / Plano" : `${value > 0 ? "+" : ""}${val}`;
      options.push(`<option value="${val}" ${val === selected ? "selected" : ""}>${text}</option>`);
    }
    return options.join("");
  }

  function addOptions(selected) {
    const options = [`<option value="" ${selected === "" ? "selected" : ""}>Select</option>`];
    for (let value = 0.75; value <= 3.50 + 0.001; value += 0.25) {
      const val = value.toFixed(2);
      options.push(`<option value="${val}" ${val === selected ? "selected" : ""}>+${val}</option>`);
    }
    return options.join("");
  }

  function renderPrescription(root, state) {
    const rx = byId(config.rxTypes, state.rxType);
    if (!rx.requiresRx || state.inputMethod !== "manual") {
      const text = rx.requiresRx ? byId(config.inputMethods, state.inputMethod).desc : "Plano lenses do not require prescription fields.";
      return `<div class="lc-v2-review-card"><h4>No manual prescription needed</h4><p>${text}</p></div>`;
    }
    return `
      <div class="lc-v2-rx-grid">
        <label class="lc-v2-field"><span>OD SPH</span><select data-lc-rx="odSph">${powerOptions(-12, 8, 0.25, state.rx.odSph)}</select></label>
        <label class="lc-v2-field"><span>OD CYL</span><select data-lc-rx="odCyl">${powerOptions(-6, 0, 0.25, state.rx.odCyl)}</select></label>
        <label class="lc-v2-field"><span>OD AXIS</span><input data-lc-rx="odAxis" type="number" min="0" max="180" step="1" value="${state.rx.odAxis}"></label>
        <label class="lc-v2-field"><span>OS SPH</span><select data-lc-rx="osSph">${powerOptions(-12, 8, 0.25, state.rx.osSph)}</select></label>
        <label class="lc-v2-field"><span>OS CYL</span><select data-lc-rx="osCyl">${powerOptions(-6, 0, 0.25, state.rx.osCyl)}</select></label>
        <label class="lc-v2-field"><span>OS AXIS</span><input data-lc-rx="osAxis" type="number" min="0" max="180" step="1" value="${state.rx.osAxis}"></label>
        <div class="lc-v2-pd-row">
          <label class="lc-v2-field">
            <span>PD mode</span>
            <div class="lc-v2-segmented">
              <button class="${state.pdMode === "single" ? "is-active" : ""}" data-lc-pd="single" type="button">Single PD</button>
              <button class="${state.pdMode === "dual" ? "is-active" : ""}" data-lc-pd="dual" type="button">Dual PD</button>
            </div>
          </label>
          ${state.pdMode === "single"
            ? `<label class="lc-v2-field"><span>PD</span><input data-lc-rx="pd" type="number" min="40" max="80" step="0.5" value="${state.rx.pd}"></label>`
            : `<label class="lc-v2-field"><span>RPD</span><input data-lc-rx="rpd" type="number" min="20" max="45" step="0.5" value="${state.rx.rpd}"></label>
               <label class="lc-v2-field"><span>LPD</span><input data-lc-rx="lpd" type="number" min="20" max="45" step="0.5" value="${state.rx.lpd}"></label>`}
          ${rx.requiresAdd ? `<label class="lc-v2-field"><span>ADD</span><select data-lc-rx="add">${addOptions(state.rx.add)}</select></label>` : ""}
        </div>
      </div>`;
  }

  function renderLensPackage(root, state) {
    normalizeState(state);
    if (state.rxType === "frame_only") {
      return `<div class="lc-v2-review-card"><h4>Frame Only</h4><p>No lens package is needed. The frame will be shipped without prescription or plano lenses.</p></div>`;
    }
    return choiceMarkup(allowedLensPackages(state), state.lensPackage, "lensPackage");
  }

  function swatchOverlayLayers(item, pkg) {
    if (pkg.colorSet === "photo") {
      return [
        "linear-gradient(90deg, rgba(255,255,255,.92) 0%, rgba(255,255,255,.62) 38%, rgba(255,255,255,.08) 72%, rgba(15,23,42,.14) 100%)",
        "linear-gradient(180deg, rgba(255,255,255,.45) 0%, rgba(255,255,255,0) 58%, rgba(15,23,42,.06) 100%)"
      ];
    }

    if (pkg.colorSet === "polarized") {
      return [
        "linear-gradient(180deg, rgba(15,23,42,.58) 0%, rgba(15,23,42,.22) 44%, rgba(15,23,42,.7) 100%)",
        "linear-gradient(90deg, rgba(255,255,255,.1) 0%, rgba(255,255,255,0) 42%, rgba(0,0,0,.24) 100%)"
      ];
    }

    if (pkg.colorSet === "tinted") {
      const isDarkTint = item.id.includes("85%");
      return isDarkTint
        ? [
          "linear-gradient(180deg, rgba(15,23,42,.48) 0%, rgba(15,23,42,.2) 42%, rgba(15,23,42,.62) 100%)",
          "linear-gradient(90deg, rgba(255,255,255,.14) 0%, rgba(255,255,255,0) 50%, rgba(0,0,0,.18) 100%)"
        ]
        : [
          "linear-gradient(90deg, rgba(255,255,255,.72) 0%, rgba(255,255,255,.42) 45%, rgba(255,255,255,.16) 100%)",
          "linear-gradient(180deg, rgba(255,255,255,.34) 0%, rgba(255,255,255,0) 62%, rgba(15,23,42,.08) 100%)"
        ];
    }

    return [
      "linear-gradient(145deg, rgba(255,255,255,.22), rgba(15,23,42,.08))"
    ];
  }

  function swatchShadow(pkg, item) {
    if (pkg.colorSet === "photo") {
      return "inset 18px 12px 24px rgba(255,255,255,.54), inset -8px -10px 18px rgba(15,23,42,.1), 0 1px 2px rgba(15,35,68,.08)";
    }

    if (pkg.colorSet === "polarized" || (pkg.colorSet === "tinted" && item.id.includes("85%"))) {
      return "inset 10px 8px 18px rgba(255,255,255,.18), inset -14px -12px 24px rgba(0,0,0,.34), 0 1px 2px rgba(15,35,68,.13)";
    }

    if (pkg.colorSet === "tinted") {
      return "inset 16px 12px 22px rgba(255,255,255,.46), inset -8px -10px 16px rgba(15,23,42,.11), 0 1px 2px rgba(15,35,68,.08)";
    }

    return "inset 12px 12px 22px rgba(255,255,255,.36), inset -10px -10px 18px rgba(15,23,42,.18), 0 1px 2px rgba(15,35,68,.1)";
  }

  function swatchStyle(item, pkg) {
    const overlayLayers = swatchOverlayLayers(item, pkg);
    return [
      "display: block",
      "width: 82px",
      "height: 82px",
      "margin: 0 auto 11px",
      "border-radius: 50%",
      "border: 1px solid rgba(51,65,85,.28)",
      `background-color: ${item.fallback || "#dbeafe"}`,
      `background-image: radial-gradient(circle at 30% 24%, rgba(255,255,255,.9) 0 10%, rgba(255,255,255,0) 30%), ${overlayLayers.join(", ")}, ${item.css}`,
      "background-repeat: no-repeat",
      "background-size: cover",
      `box-shadow: ${swatchShadow(pkg, item)}`
    ].join("; ");
  }

  function swatchClassName(item, selected, pkg) {
    const classes = ["lc-v2-swatch"];
    if (item.id === selected) classes.push("is-active");
    if (pkg && pkg.colorSet === "photo") classes.push("lc-v2-swatch--photo");
    if (pkg && pkg.colorSet === "polarized") classes.push("lc-v2-swatch--polarized");
    if (pkg && pkg.colorSet === "tinted") {
      classes.push("lc-v2-swatch--tinted");
      classes.push(item.id.indexOf("85%") > -1 ? "lc-v2-swatch--tinted-dark" : "lc-v2-swatch--tinted-light");
    }
    return classes.join(" ");
  }

  function swatchNote(item, pkg) {
    if (!pkg || pkg.colorSet !== "tinted") return "";
    const label = item.id.indexOf("85%") > -1 ? "85% Dark tint" : "30% Light tint";
    return `<em class="lc-v2-swatch-note">${label}</em>`;
  }

  function swatches(list, selected, group, pkg) {
    return `<div class="lc-v2-swatch-grid">${list.map((item) => `
      <button class="${swatchClassName(item, selected, pkg)}" type="button" data-lc-group="${group}" data-lc-id="${item.id}">
        <span class="lc-v2-lens-sample" aria-hidden="true" style="${swatchStyle(item, pkg)}"></span>
        <strong>${item.name}</strong>
        <span>${item.id}</span>
        ${swatchNote(item, pkg)}
      </button>
    `).join("")}</div>`;
  }

  function renderColor(root, state) {
    normalizeState(state);
    const pkg = selectedPackage(state);
    if (!pkg.color) {
      return `<div class="lc-v2-review-card"><h4>No color needed</h4><p>${pkg.name} does not require color or density selection.</p></div>`;
    }
    const colors = colorOptions(state);
    return `
      <div class="lc-v2-review-card" style="margin-bottom:14px"><h4>Choose lens color</h4></div>
      ${swatches(colors, state.color, "color", pkg)}`;
  }

  function renderIndexAddons(root, state) {
    normalizeState(state);
    if (state.rxType === "frame_only") {
      return `<div class="lc-v2-review-card"><h4>Frame Only</h4><p>No lens index or add-ons are needed.</p></div>`;
    }
    const indexes = allowedIndexes(state);
    const addons = allowedAddons(state);
    const regularIndexes = indexes.filter((item) => item.id.indexOf("_bluelight") === -1);
    const blueLightIndexes = indexes.filter((item) => item.id.indexOf("_bluelight") > -1);
    const optionSection = (title, help, body) => `
      <section class="lc-v2-option-section">
        <div class="lc-v2-option-section__head">
          <h4 class="lc-v2-option-section__title">${title}</h4>
          ${help ? `<p class="lc-v2-option-section__help">${help}</p>` : ""}
        </div>
        <div class="lc-v2-option-section__body">${body}</div>
      </section>`;
    const regularIndexChooser = regularIndexes.length > 1
      ? optionSection("Lens Index", "Choose the lens thickness that best fits your prescription.", choiceMarkup(regularIndexes, state.index, "index"))
      : optionSection("Lens Index", "Choose the lens thickness that best fits your prescription.", `<div class="lc-v2-review-card"><h4>Lens index</h4><p>1.56 Standard is included for this lens type.</p></div>`);
    const blueLightIndexChooser = blueLightIndexes.length
      ? optionSection("Blue Light Index", "Adds blue light filtering to clear lenses.", choiceMarkup(blueLightIndexes, state.index, "index"))
      : "";
    const addonChooser = addons.length
      ? optionSection("Add-ons", "Optional coating upgrades for easier daily care.", `<div class="lc-v2-addon-grid">${addons.map((addon) => `
          <label class="lc-v2-addon">
            <input type="checkbox" value="${addon.id}" ${state.addons.has(addon.id) ? "checked" : ""}>
            <span class="lc-v2-choice-icon" aria-hidden="true">${icons[addon.icon] || icons.addon}</span>
            <span><strong>${addon.name} +${money(addon.price)}</strong><span>${addon.desc}</span></span>
          </label>
        `).join("")}</div>`)
      : optionSection("Add-ons", "", `<div class="lc-v2-review-card"><h4>Add-ons</h4><p>No add-ons are available for this lens type.</p></div>`);
    return `
      ${regularIndexChooser}
      ${blueLightIndexChooser}
      ${addonChooser}`;
  }

  function reviewDisplayValue(value) {
    return String(value || "").trim() || "Not provided";
  }

  function reviewRows(rows) {
    return `<div class="lc-v2-review-summary">${rows.map((row) => `
      <div class="lc-v2-review-row">
        <span class="lc-v2-review-label">${row.label}</span>
        <strong class="lc-v2-review-value">${row.value}</strong>
      </div>
    `).join("")}</div>`;
  }

  function reviewSummaryRows(state) {
    const rx = byId(config.rxTypes, state.rxType);
    if (rx.frameOnly) {
      return [
        { label: "Selection", value: "Frame Only" },
        { label: "Prescription", value: "Not required" },
        { label: "Lens Upgrade Price", value: money(0) }
      ];
    }

    const pkg = selectedPackage(state);
    const index = selectedIndex(state);
    const addons = selectedAddons(state).map((addon) => addon.name).join(", ") || "None";
    return [
      { label: "Prescription Type", value: rx.name },
      { label: "Lens Package", value: pkg.name },
      ...(pkg.color ? [{ label: "Lens Color", value: colorText(state) }] : []),
      { label: "Lens Index", value: index.name },
      { label: "Add-ons", value: addons },
      { label: "Lens Upgrade Price", value: money(lensPrice(state)) }
    ];
  }

  function reviewPrescriptionRows(state) {
    const rx = byId(config.rxTypes, state.rxType);
    if (rx.frameOnly) {
      return [{ label: "Prescription", value: "Prescription not required." }];
    }
    if (!rx.requiresRx) {
      return [{ label: "Prescription", value: "Prescription not required for plano lenses." }];
    }

    const pd = state.pdMode === "dual"
      ? `RPD ${reviewDisplayValue(state.rx.rpd)} / LPD ${reviewDisplayValue(state.rx.lpd)}`
      : `PD ${reviewDisplayValue(state.rx.pd)}`;

    if (state.rxType === "readers") {
      const rows = [
        { label: "OD", value: `SPH ${reviewDisplayValue(state.rx.odSph)}` },
        { label: "OS", value: `SPH ${reviewDisplayValue(state.rx.osSph)}` },
        { label: "PD", value: pd }
      ];
      if (state.rx.odCyl || state.rx.odAxis) {
        rows.splice(1, 0, { label: "OD Astigmatism", value: `CYL ${reviewDisplayValue(state.rx.odCyl)} / AXIS ${reviewDisplayValue(state.rx.odAxis)}` });
      }
      if (state.rx.osCyl || state.rx.osAxis) {
        rows.splice(rows.length - 1, 0, { label: "OS Astigmatism", value: `CYL ${reviewDisplayValue(state.rx.osCyl)} / AXIS ${reviewDisplayValue(state.rx.osAxis)}` });
      }
      return rows;
    }

    return [
      { label: "OD", value: `SPH ${reviewDisplayValue(state.rx.odSph)} / CYL ${reviewDisplayValue(state.rx.odCyl)} / AXIS ${reviewDisplayValue(state.rx.odAxis)}` },
      { label: "OS", value: `SPH ${reviewDisplayValue(state.rx.osSph)} / CYL ${reviewDisplayValue(state.rx.osCyl)} / AXIS ${reviewDisplayValue(state.rx.osAxis)}` },
      { label: "PD", value: pd },
      ...(rx.requiresAdd ? [{ label: "ADD", value: reviewDisplayValue(state.rx.add) }] : [])
    ];
  }

  function renderReview(root, state) {
    normalizeState(state);
    const breakdownRows = priceRows(state).map((row) => state.rxType === "non_rx" && row.label === "Prescription method" ? { ...row, value: "Not required" } : row);
    return `
      <div class="lc-v2-review-layout">
        <section class="lc-v2-review-section lc-v2-display-prices" aria-label="Estimated price per pair">
          <h4>Estimated price per pair</h4>
          <div><span>Frame</span><strong data-lc-display-frame>${money(state.framePrice)}</strong></div>
          <div><span>Lens additions</span><strong data-lc-display-lenses>${money(lensPrice(state))}</strong></div>
          <div class="lc-v2-display-estimate"><span>Estimated total</span><strong data-lc-display-estimate>${money(totalPrice(state))}</strong></div>
          <p>Shipping and taxes calculated at checkout.</p>
        </section>
        <section class="lc-v2-review-section">
          <div class="lc-v2-review-section__head">
            <h4>Your Lens Summary</h4>
          </div>
          ${reviewRows(reviewSummaryRows(state))}
        </section>

        <section class="lc-v2-review-section">
          <div class="lc-v2-review-section__head">
            <h4>Prescription Details</h4>
          </div>
          ${reviewRows(reviewPrescriptionRows(state))}
        </section>

        <section class="lc-v2-review-section">
          <div class="lc-v2-review-section__head">
            <h4>Price Breakdown</h4>
          </div>
          <table class="lc-v2-table lc-v2-review-price-table">
            <thead><tr><th>Item</th><th>Selection</th><th>Price</th></tr></thead>
            <tbody>${breakdownRows.map((row) => `<tr><td>${row.label}</td><td>${row.value}</td><td>${row.price ? `+${money(row.price)}` : "Included"}</td></tr>`).join("")}</tbody>
          </table>
          <div class="lc-v2-review-total">
            <span>Lens Upgrade Total</span>
            <strong>${money(lensPrice(state))}</strong>
          </div>
        </section>

        <section class="lc-v2-review-section lc-v2-review-note">
          <div class="lc-v2-review-section__head">
            <h4>Customer Note</h4>
          </div>
          <label class="lc-v2-field"><textarea data-lc-note placeholder="Special color request, urgent order, prescription note...">${state.note}</textarea></label>
        </section>

        <section class="lc-v2-review-section lc-v2-review-preview">
          <div class="lc-v2-review-section__head">
            <h4>Order Note Preview</h4>
          </div>
          <label class="lc-v2-field"><textarea readonly>${state.rxType === "non_rx" ? orderNote(root, state).replace(/^Prescription Method:.*$/m, "Prescription Method: Not required") : orderNote(root, state)}</textarea></label>
        </section>
      </div>`;
  }

  function bindRoot(root) {
    root.addEventListener("click", (event) => {
      if (event.target.closest("[data-lc-open]")) openModal(root);
    });
  }

  function bindModal(modal) {
    modal.addEventListener("click", async (event) => {
      if (!activeRoot) return;
      const state = getState(activeRoot);

      if (event.target.closest("[data-lc-close]")) {
        closeModal();
        return;
      }

      if (event.target.closest("[data-lc-back]")) {
        if (state.step > 0) state.step -= 1;
        renderModal();
        return;
      }

      if (event.target.closest("[data-lc-next]")) {
        const validationMessages = validate(state);
        if ((isPrescriptionStep(state) || isReviewStep(state)) && validationMessages.length) {
          const warning = modal.querySelector("[data-lc-warning]");
          if (warning) warning.textContent = validationMessages.join(" ");
          return;
        }
        const active = activeSteps(state);
        state.step = currentStepIndex(state, active);
        if (state.step < active.length - 1) {
          state.step += 1;
          renderModal();
        } else {
          const form = findDawnProductForm(activeRoot);
          const button = modal.querySelector("[data-lc-next]");

          if (!form) {
            const warning = modal.querySelector("[data-lc-warning]");
            if (warning) warning.textContent = "Unable to find the product form. Please refresh and try again.";
            return;
          }

          state.confirmed = true;
          writeProperties(activeRoot);
          renderSummary(activeRoot);
          setSubmitLoading(button, true);

          try {
            const added = await addConfiguredLensesToCart(activeRoot, form);
            if (added) window.location.href = cartUrl();
          } catch (error) {
            console.error(error);
            const warning = modal.querySelector("[data-lc-warning]");
            if (warning) warning.textContent = "Unable to add lenses to cart. Please try again.";
          } finally {
            setSubmitLoading(button, false);
          }
        }
        return;
      }

      const groupChoice = event.target.closest("[data-lc-group]");
      if (groupChoice) {
        const group = groupChoice.dataset.lcGroup;
        if (group === "color") state.color = groupChoice.dataset.lcId;
        else if (group === "mirror") state.mirror = groupChoice.dataset.lcId;
        else if (group === "mercury") state.mercury = groupChoice.dataset.lcId;
        else state[group] = groupChoice.dataset.lcId;
        if (["rxType", "lensPackage", "index"].includes(group)) normalizeState(state);
        renderModal();
        return;
      }

      const depthChoice = event.target.closest("[data-lc-depth]");
      if (depthChoice) {
        state.depth = depthChoice.dataset.lcDepth;
        renderModal();
        return;
      }

      const pdChoice = event.target.closest("[data-lc-pd]");
      if (pdChoice) {
        state.pdMode = pdChoice.dataset.lcPd;
        renderModal();
      }
    });

    modal.addEventListener("input", (event) => {
      if (!activeRoot) return;
      const state = getState(activeRoot);
      const rxInput = event.target.closest("[data-lc-rx]");
      if (rxInput) {
        state.rx[rxInput.dataset.lcRx] = rxInput.value;
        normalizeState(state);
      }
      const noteInput = event.target.closest("[data-lc-note]");
      if (noteInput) state.note = noteInput.value;
      renderModalTotals(state);
    });

    modal.addEventListener("change", (event) => {
      if (!activeRoot) return;
      const state = getState(activeRoot);
      const addon = event.target.closest(".lc-v2-addon input");
      if (!addon) return;
      if (addon.checked) state.addons.add(addon.value);
      else state.addons.delete(addon.value);
      normalizeState(state);
      renderModal();
    });
  }

  function renderModalTotals(state) {
    normalizeState(state);
    const modal = document.getElementById(MODAL_ID);
    if (!modal) return;
    modal.querySelector("[data-lc-lens-price]").textContent = money(lensPrice(state));
    modal.querySelector("[data-lc-warning]").textContent = visibleValidationMessages(state).join(" ");
  }

  function cartAddUrl() {
    const root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root
      ? window.Shopify.routes.root
      : "/";
    return `${root}cart/add.js`;
  }

  function cartUrl() {
    const root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root
      ? window.Shopify.routes.root
      : "/";
    return `${root}cart`;
  }

  function formVariantId(form) {
    const field = form.querySelector('input[name="id"], select[name="id"]');
    return field ? Number(field.value) : 0;
  }

  function formQuantity(form) {
    const field = form.querySelector('input[name="quantity"]');
    const quantity = field ? Number.parseInt(field.value, 10) : 1;
    return Number.isFinite(quantity) && quantity > 0 ? quantity : 1;
  }

  function submitButton(form) {
    return form.querySelector('[type="submit"], button[name="add"]');
  }

  function setSubmitLoading(button, loading) {
    if (!button) return;
    if (loading) {
      button.dataset.lcOriginalText = button.textContent;
      button.disabled = true;
      button.textContent = "Adding...";
    } else {
      button.disabled = false;
      if (button.dataset.lcOriginalText) {
        button.textContent = button.dataset.lcOriginalText;
        delete button.dataset.lcOriginalText;
      }
    }
  }

  function createJoyeConfigurationId() {
    if (window.crypto && typeof window.crypto.randomUUID === "function") {
      return window.crypto.randomUUID();
    }
    const randomPart = () => Math.random().toString(36).slice(2, 10);
    return `joye-${Date.now().toString(36)}-${randomPart()}-${randomPart()}`;
  }

  async function addConfiguredLensesToCart(root, form) {
    const state = getState(root);
    normalizeState(state);
    const validationMessages = validate(state);
    if (validationMessages.length) {
      setStepById(state, "prescription");
      alert("Please complete your prescription before adding to cart.");
      openModal(root);
      const modal = document.getElementById(MODAL_ID);
      const warning = modal ? modal.querySelector("[data-lc-warning]") : null;
      if (warning) warning.textContent = validationMessages.join(" ");
      return false;
    }

    const mainVariantId = formVariantId(form);
    const quantity = formQuantity(form);
    const price = lensPrice(state);
    const properties = buildLensProperties(root, state);

    if (!mainVariantId) {
      throw new Error("Missing main product variant id.");
    }

    const items = [
      {
        id: Number(mainVariantId),
        quantity,
        properties
      }
    ];

    if (price > 0) {
      const upgradeVariantId = upgradeVariantIdForPrice(price);
      if (!upgradeVariantId) {
        console.error("Missing Lens Upgrade variant for price:", price);
        alert(`Lens upgrade price ${money(price)} is not configured. Please contact store support.`);
        return false;
      }

      const joyeConfigurationId = createJoyeConfigurationId();
      properties["_Joye Configuration ID"] = joyeConfigurationId;

      items.push({
        id: Number(upgradeVariantId),
        quantity,
        properties: {
          "Lens Upgrade For": root.dataset.lcProductTitle || document.title || "Eyeglasses",
          "Lens Configuration": properties["Lens Configuration"],
          "Prescription": properties["Prescription"],
          "Lens Package": properties["Lens Package"],
          "Lens Color": properties["Lens Color"],
          "Lens Index": properties["Lens Index"],
          "Lens Add-ons": properties["Lens Add-ons"],
          "Linked Product Variant": String(mainVariantId),
          "_Joye Configuration ID": joyeConfigurationId
        }
      });
    }

    const response = await fetch(cartAddUrl(), {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json"
      },
      body: JSON.stringify({ items })
    });

    if (!response.ok) {
      const text = await response.text();
      throw new Error(text || "Unable to add configured lenses to cart.");
    }

    return true;
  }

  function bindCartForm(root) {
    const form = findDawnProductForm(root);
    if (!form || boundForms.has(form)) return;
    boundForms.add(form);

    form.addEventListener("submit", async (event) => {
      const activeConfigurator = document.documentElement.contains(root) ? root : document.querySelector("[data-lc-root]");
      if (!activeConfigurator) return;

      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();

      const button = submitButton(form);
      setSubmitLoading(button, true);

      try {
        writeProperties(activeConfigurator);
        const added = await addConfiguredLensesToCart(activeConfigurator, form);
        if (added) window.location.href = cartUrl();
      } catch (error) {
        console.error(error);
        alert("Unable to add lenses to cart. Please try again.");
      } finally {
        setSubmitLoading(button, false);
      }
    }, true);
  }

  function init() {
    ensureModal();
    document.querySelectorAll("[data-lc-root]").forEach((root) => {
      getState(root);
      bindRoot(root);
      renderSummary(root);
      writeProperties(root);
      bindCartForm(root);
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();






